import { render } from "./Cita.vue?vue&type=template&id=0874edba&scoped=true"
import script from "./Cita.vue?vue&type=script&lang=js"
export * from "./Cita.vue?vue&type=script&lang=js"

import "@/assets/css/listaRegistros.css?vue&type=style&index=0&id=0874edba&scoped=true&lang=css"
import "./Cita.vue?vue&type=style&index=1&id=0874edba&scoped=true&lang=css"
import "./Cita.vue?vue&type=style&index=2&id=0874edba&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0874edba"]])

export default __exports__